import React, { useContext } from 'react';
import { LanguageContext } from './LanguageContext';
import './PrivacyPolicy.css'; // Create this CSS file for styling if needed

function PrivacyPolicy() {
    const { language } = useContext(LanguageContext);

    return (
        <div className="container my-5">
            <h1 className="text-center mb-4">
                {language === 'en' ? 'Privacy Policy' : 'Gizlilik Politikası'}
            </h1>
            <div className="content">
                {language === 'en' ? (
                    <>
                        <h2>Privacy Policy</h2>
                        <h3>1. Introduction</h3>
                        <p>Welcome to Tacosoft. We respect your privacy and are committed to protecting your personal data. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website.</p>
                        
                        <h3>2. Data We Collect</h3>
                        <p>We may collect the following types of personal data:</p>
                        <ul>
                            <li>Identity Information (Name, surname, company name, etc.)</li>
                            <li>Contact Information (Email address, phone number, etc.)</li>
                            <li>Technical Data (IP address, browser type, operating system, etc.)</li>
                            <li>Marketing and Communication Data (Your preferences for receiving communications)</li>
                            <li>Usage Data (Pages visited, time spent on the site, interaction data)</li>
                        </ul>
                        
                        <h3>3. How We Use Your Data</h3>
                        <p>We process your personal data for the following purposes:</p>
                        <ul>
                            <li>To provide and improve our services.</li>
                            <li>To communicate with you regarding inquiries or offers.</li>
                            <li>To analyze website usage and enhance user experience.</li>
                            <li>To comply with legal obligations.</li>
                        </ul>
                        
                        <h3>4. Legal Basis for Processing</h3>
                        <p>We process personal data based on:</p>
                        <ul>
                            <li>Your consent (e.g., marketing communications).</li>
                            <li>Contractual necessity (e.g., providing services).</li>
                            <li>Legal obligations (e.g., compliance with regulations).</li>
                            <li>Legitimate interest (e.g., website analytics).</li>
                        </ul>
                        
                        <h3>5. Sharing and Transferring Data</h3>
                        <p>We may share your data:</p>
                        <ul>
                            <li>With service providers (e.g., hosting, analytics, marketing).</li>
                            <li>When required by law enforcement or legal obligations.</li>
                            <li>With business partners, if necessary.</li>
                        </ul>
                        <p>Data may be transferred internationally in compliance with KVKK and GDPR regulations.</p>
                        
                        <h3>6. Cookies and Tracking</h3>
                        <p>Our website uses cookies to:</p>
                        <ul>
                            <li>Improve user experience.</li>
                            <li>Analyze site performance.</li>
                            <li>Provide personalized content and advertisements.</li>
                        </ul>
                        <p>You can manage cookies through your browser settings.</p>
                        
                        <h3>7. Your Rights</h3>
                        <p>Under the KVKK and GDPR, you have the right to:</p>
                        <ul>
                            <li>Access your data.</li>
                            <li>Request correction of inaccurate data.</li>
                            <li>Request deletion ("right to be forgotten").</li>
                            <li>Restrict processing under certain conditions.</li>
                            <li>Object to processing for direct marketing.</li>
                            <li>Withdraw consent at any time.</li>
                        </ul>
                        <p>To exercise these rights, please contact info@tacosoft.com.tr</p>
                        
                        <h3>8. Data Retention</h3>
                        <p>We retain personal data for as long as necessary to fulfill the purposes outlined in this policy or as required by law.</p>
                        
                        <h3>9. Security Measures</h3>
                        <p>We implement industry-standard security measures to protect your data, including encryption and access control.</p>
                        
                        <h3>10. Contact Information</h3>
                        <p>If you have any questions regarding this policy, you may contact us at:</p>
                        <p>Company Name: Tacosoft<br />
                        Email: info@tacosoft.com.tr<br />
                        Address: Silivri, İstanbul</p>
                        
                        <h3>11. Changes to this Policy</h3>
                        <p>We may update this policy periodically. The latest version will always be available on our website.</p>
                        <p>This policy complies with KVKK (Law No. 6698) and GDPR requirements.</p>
                    </>
                ) : (
                    <>
                        <h2>Gizlilik Politikası</h2>
                        <h3>1. Giriş</h3>
                        <p>Tacosoft'a hoş geldiniz. Gizliliğinize saygı duyuyor ve kişisel verilerinizi korumaya kararlıyız. Bu Gizlilik Politikası, web sitemizi ziyaret ettiğinizde bilgilerinizi nasıl topladığımızı, kullandığımızı, ifşa ettiğimizi ve koruduğumuzu açıklar.</p>
                        
                        <h3>2. Topladığımız Veriler</h3>
                        <p>Aşağıdaki türde kişisel verileri toplayabiliriz:</p>
                        <ul>
                            <li>Kimlik Bilgileri (Ad, soyad, şirket adı vb.)</li>
                            <li>İletişim Bilgileri (E-posta adresi, telefon numarası vb.)</li>
                            <li>Teknik Veriler (IP adresi, tarayıcı türü, işletim sistemi vb.)</li>
                            <li>Pazarlama ve İletişim Verileri (İletişim tercihleri)</li>
                            <li>Kullanım Verileri (Ziyaret edilen sayfalar, sitede geçirilen süre, etkileşim verileri)</li>
                        </ul>
                        
                        <h3>3. Verilerinizi Nasıl Kullanıyoruz?</h3>
                        <p>Kişisel verilerinizi aşağıdaki amaçlarla işliyoruz:</p>
                        <ul>
                            <li>Hizmetlerimizi sağlamak ve geliştirmek.</li>
                            <li>Soru veya tekliflerle ilgili sizinle iletişim kurmak.</li>
                            <li>Web sitesi kullanımını analiz etmek ve kullanıcı deneyimini iyileştirmek.</li>
                            <li>Yasal yükümlülüklere uymak.</li>
                        </ul>
                        
                        <h3>4. İşleme İçin Hukuki Dayanak</h3>
                        <p>Kişisel verileri aşağıdaki hukuki dayanaklarla işliyoruz:</p>
                        <ul>
                            <li>Açık rızanız (örn. pazarlama iletişimleri).</li>
                            <li>Sözleşmesel gereklilik (örn. hizmet sağlamak).</li>
                            <li>Yasal yükümlülükler (örn. düzenlemelere uyum).</li>
                            <li>Meşru menfaat (örn. web sitesi analitiği).</li>
                        </ul>
                        
                        <h3>5. Verilerin Paylaşımı ve Aktarımı</h3>
                        <p>Verilerinizi şu durumlarda paylaşabiliriz:</p>
                        <ul>
                            <li>Hizmet sağlayıcılarla (örn. barındırma, analiz, pazarlama).</li>
                            <li>Hukuki gereklilikler doğrultusunda yetkili mercilerle.</li>
                            <li>İş ortaklarıyla, gerektiğinde.</li>
                        </ul>
                        <p>Verileriniz, KVKK ve GDPR hükümlerine uygun olarak yurt dışına aktarılabilir.</p>
                        
                        <h3>6. Çerezler ve Takip Teknolojileri</h3>
                        <p>Sitemiz, aşağıdaki amaçlarla çerezler kullanmaktadır:</p>
                        <ul>
                            <li>Kullanıcı deneyimini iyileştirmek.</li>
                            <li>Site performansını analiz etmek.</li>
                            <li>Kişiselleştirilmiş içerik ve reklamlar sunmak.</li>
                        </ul>
          
                      <p>Çerezleri tarayıcı ayarlarınızdan yönetebilirsiniz.</p>
                        
                        <h3>7. Haklarınız</h3>
                        <p>KVKK ve GDPR kapsamında aşağıdaki haklara sahipsiniz:</p>
                        <ul>
                            <li>Verilerinize erişme hakkı.</li>
                            <li>Yanlış verileri düzeltme hakkı.</li>
                            <li>Verilerin silinmesini talep etme hakkı ("unutulma hakkı").</li>
                            <li>Belirli durumlarda işlemenin kısıtlanmasını isteme hakkı.</li>
                            <li>Doğrudan pazarlama için işlemeye itiraz etme hakkı.</li>
                            <li>Her zaman onayınızı geri çekme hakkı.</li>
                        </ul>
                        <p>Bu haklarınızı kullanmak için info@tacosoft.com.tr adresine başvurabilirsiniz.</p>
                        
                        <h3>8. Veri Saklama Süresi</h3>
                        <p>Kişisel verileri, bu politikada belirtilen amaçları gerçekleştirmek veya yasal zorunluluklara uymak için gerekli olduğu sürece saklarız.</p>
                        
                        <h3>9. Güvenlik Önlemleri</h3>
                        <p>Verilerinizi korumak için şifreleme ve erişim kontrolü gibi endüstri standardı güvenlik önlemleri uyguluyoruz.</p>
                        
                        <h3>10. İletişim Bilgileri</h3>
                        <p>Bu politika hakkında sorularınız varsa, bizimle şu adreslerden iletişime geçebilirsiniz:</p>
                        <p>Şirket Adı: Tacosoft<br />
                        E-posta: info@tacosoft.com.tr<br />
                        Adres: Silivri, İstanbul</p>
                        
                        <h3>11. Politika Değişiklikleri</h3>
                        <p>Bu politikayı periyodik olarak güncelleyebiliriz. En güncel versiyon her zaman web sitemizde bulunacaktır.</p>
                        <p>Bu politika, KVKK (6698 Sayılı Kanun) ve GDPR gerekliliklerine uygun olarak hazırlanmıştır.</p>
                    </>
                )}
            </div>
        </div>
    );
}

export default PrivacyPolicy; 